// @flow

import React from 'react';
import type { ComponentType } from 'react';

type State = { collapsed: boolean };

const withLimit = (WrappedComponent: ComponentType<*>) => class extends React.Component<*, State> {
  constructor() {
    super();
    this.state = {
      collapsed: true,
    };
  }

    handleChange = () => {
      this.setState((prevState: State) => ({
        collapsed: !prevState.collapsed,
      }));
    }

    render() {
      const { minimalistic, collapsible } = this.props;
      const { collapsed } = this.state;
      return (
        <WrappedComponent
          collapsed={(minimalistic || collapsible) && collapsed}
          onCollapse={this.handleChange}
          {...this.props}
        />
      );
    }
};

export default withLimit;
